import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocAutomationsRoute: InvariantJiraRoute = {
	name: 'eoc-automations',
	path: '/jira/ops/teams/:teamId/automations',
	exact: true,
};
